const Types = {
  GET_PUSH_NOTIFICATIONS_SUCCESS: "GET_PUSH_NOTIFICATIONS_SUCCESS",
  PUSH_NOTIFICATIONS_LOADING: "PUSH_NOTIFICATIONS_LOADING",
};

export default Types;
